
export const LeftSidebarCollapse: React.FC = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_424_6516)">
      <mask id="mask0_424_6516" maskUnits="userSpaceOnUse" x="0" y="0"
        width="20" height="20">
        <path d="M0 0H20V20H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_424_6516)">
        <path
          d="M5.98875 18.125V1.875M16.805 18.125H3.195C2.67875 18.125 2.18375 17.935 1.82 17.5962C1.64189 17.4342 1.49928 17.2371 1.40117 17.0172C1.30307 16.7973 1.2516 16.5595 1.25 16.3188V3.68125C1.25 2.68375 2.12 1.875 3.195 1.875H16.805C17.88 1.875 18.75 2.68375 18.75 3.68125V16.3188C18.75 17.3163 17.8788 18.125 16.805 18.125Z"
          stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M10.0213 9.5225C9.97479 9.56893 9.93791 9.62408 9.91275 9.68478C9.88759 9.74548 9.87463 9.81054 9.87463 9.87625C9.87463 9.94196 9.88759 10.007 9.91275 10.0677C9.93791 10.1284 9.97479 10.1836 10.0213 10.23L13.0213 13.23C13.0912 13.3 13.1803 13.3477 13.2774 13.367C13.3744 13.3863 13.475 13.3764 13.5664 13.3386C13.6578 13.3007 13.736 13.2365 13.7909 13.1542C13.8458 13.0719 13.8751 12.9752 13.875 12.8762V6.87625C13.8751 6.7773 13.8458 6.68055 13.7909 6.59826C13.736 6.51596 13.6578 6.45181 13.5664 6.41394C13.475 6.37606 13.3744 6.36616 13.2774 6.38548C13.1803 6.40481 13.0912 6.45249 13.0213 6.5225L10.0213 9.5225Z"
          fill="currentColor" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_424_6516">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)